<template>
  <div v-if="!isLoading">
    <div v-if="activeBoard  && activeBoard.id" class="backlog-container mt-0">
        <div class="mt-3 mb-4 sprint-header">
    <span style="color: var(--text-color)">{{ activeBoard.name }} ({{ bugForCurrentBoard.length }} issues)</span>
    <el-button @click="completeSprint" class="complete-sprint-btn">Complete Sprint</el-button>
</div>

        <ul>
        <li v-for="bug in bugForCurrentBoard" :key="bug.id">
            <el-row class="bug-row">
                <el-col :span="15">
                        <el-checkbox class="mr-2"  :model-value="selectedBugsInBoard[bug.id]"
            @update:model-value="toggleSelectionInBoard(bug.id)" />
                    <span style="font-size: 12px;">{{  bug.id }}</span>
                    <span class="summary ml-2">{{ bug.summary }}</span>
                </el-col>

                <el-col :span="7">
                    <el-tag class="mr-1">{{  bug.appType }}</el-tag>
                    <el-tag class="mr-1" type="info" v-if="bug.category">{{  bug.category }}</el-tag>
                    <el-tag type="warning" v-if="bug.status">{{  bug.status }}</el-tag>

                </el-col>

                <el-col :span="2" style="
    text-align: right;
    padding-right: 10px;
">
                    <el-popover placement="bottom-start" :width="300" trigger="click">
              <template #reference>
                <button v-if="bug.assignedTo">
                  <span
                    class="avatar mr-0"
                    >{{ getInitials(bug.assignedTo) }}</span
                  >
                </button>
                <button v-else class="operations-btn">
                  <i class="ri-user-fill"></i>
                </button>
              </template>
              <template #default>
                <el-select
                  :model-value="bug.assignedTo"
                  @update:model-value="updateAssignment($event, bug)"
                  placeholder="Assign to"
                  style="width: 100% !important"
                >
                  <el-option
                    class="assign-to-select"
                    v-for="item in ['Arvin Tashakori', 'Megan Ma']"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    <span class="avatar">{{ getInitials(item) }}</span>
                    <span>{{ item }}</span>
                  </el-option>
                </el-select>
              </template>
            </el-popover>

            <el-dropdown @command="moveToBacklog(bug)">
    <span class="el-dropdown-link ml-3">
        <i class="ri-menu-line" style="vertical-align: baseline; color: orange; font-size: 17px;"></i>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item v-if="Object.keys(selectedBugsInBoard).length">Move to backlog ({{ Object.keys(selectedBugsInBoard).length }} SELECTED)</el-dropdown-item>
        <el-dropdown-item v-else>
        Move to backlog
        </el-dropdown-item>
    </el-dropdown-menu>
    </template>
  </el-dropdown>
                </el-col>
            </el-row>
        </li>
    </ul>
    </div>
    <div v-else class="backlog-container mt-0 pb-4">
        <el-button class="mt-3" @click="newBoardDialogVisible = true">Create New Board</el-button>
        <el-dialog
        :model-value="newBoardDialogVisible"
        class="preview-dialog"
        @close="newBoardDialogVisible = false"
        width="30%"
      >
        <div class="dialog-header">
          <h5>Create New Board</h5>
        </div>
        <div class="dialog-content">
          <el-form :model="newBoardForm" label-position="top" :rules="boardFormRules">
            <el-form-item label="Board Name" class="mt-3" prop="name">
              <el-input :model-value="newBoardForm.name" @update:model-value="value => newBoardForm.name = value"/>
            </el-form-item>
            <el-form-item label="Board Description">
                <el-input :model-value="newBoardForm.description" @update:model-value="value => newBoardForm.description = value"/>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-footer">
          <el-button @click="newBoardDialogVisible = false">Cancel</el-button>
          <el-button @click="createNewBoard">Create</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="backlog-container">
        <div class="mt-3">
            <p>Backlog ({{ backlogReports.length }} issues)</p>
        </div>
        <ul class="mt-3">
        <li v-for="bug in backlogReports" :key="bug.id">
            <el-row class="bug-row">
                <el-col :span="15">
                        <el-checkbox class="mr-2" :model-value="selectedBugsInBacklog[bug.id]"
            @update:model-value="toggleSelectionInBacklog(bug.id)" />
                    <span style="font-size: 12px;">{{  bug.id }}</span>
                    <span class="summary ml-2">{{ bug.summary }}</span>
                </el-col>

                <el-col :span="7">
                    <el-tag class="mr-1">{{  bug.appType }}</el-tag>
                    <el-tag class="mr-1" type="info" v-if="bug.category">{{  bug.category }}</el-tag>
                    <el-tag type="success" v-if="bug.status">{{  bug.status }}</el-tag>

                </el-col>

                <el-col :span="2" style="
    text-align: right;
    padding-right: 10px;
">
                    <el-popover placement="bottom-start" :width="300" trigger="click">
              <template #reference>
                <button v-if="bug.assignedTo">
                  <span
                    class="avatar mr-0"
                    >{{ getInitials(bug.assignedTo) }}</span
                  >
                </button>
                <button v-else class="operations-btn">
                  <i class="ri-user-fill"></i>
                </button>
              </template>
              <template #default>
                <el-select
                  :model-value="bug.assignedTo"
                  @update:model-value="updateAssignment($event, bug)"
                  placeholder="Assign to"
                  style="width: 100% !important"
                >
                  <el-option
                    class="assign-to-select"
                    v-for="item in ['Arvin Tashakori', 'Megan Ma']"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    <span class="avatar">{{ getInitials(item) }}</span>
                    <span>{{ item }}</span>
                  </el-option>
                </el-select>
              </template>
            </el-popover>

            <el-dropdown v-if="activeBoard && activeBoard.id" @command="moveToCurrentBoard(bug)">
    <span class="el-dropdown-link ml-3">
        <i class="ri-menu-line" style="vertical-align: baseline; color: orange; font-size: 17px;"></i>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item v-if="Object.keys(selectedBugsInBacklog).length">Move to {{ activeBoard.name }} ({{ Object.keys(selectedBugsInBacklog).length }} SELECTED)</el-dropdown-item>
        <el-dropdown-item v-else>
        Move to {{ activeBoard.name }}
        </el-dropdown-item>
    </el-dropdown-menu>
    </template>
  </el-dropdown>
                </el-col>
            </el-row>
        </li>
    </ul>
    </div>
  </div>
  <div v-else class="p-3">
    <el-skeleton class="m-2 mt-4 mr-5" :rows="10" animated />

  </div>
  </template>

<script>
import { onMounted, ref, watch } from 'vue'
import getBugReports from '../../../composables/getBugReports'
import useCollection from '../../../services/useCollection'
import { updateDocument } from '../../../services/useDocument'

export default {
  name: 'BugsBacklog',
  setup () {
    const { loadAllBacklogBugReports, getActiveBoard, loadBugReportsForActiveBoard } = getBugReports()
    const bugForCurrentBoard = ref([])
    const backlogReports = ref([])
    const isLoading = ref(false)
    const activeBoard = ref(null)
    const newBoardDialogVisible = ref(false)
    const selectedBugsInBoard = ref({})
    const selectedBugsInBacklog = ref({})

    const newBoardForm = ref({
      name: '',
      description: '',
      isActive: true
    })
    const boardFormRules = ref({
      name: [{ required: true, message: 'Please enter a board name', trigger: 'blur' }]
    })
    const { addDocToDb } = useCollection('bugBoards')

    onMounted(async () => {
      isLoading.value = true
      backlogReports.value = await loadAllBacklogBugReports()
      activeBoard.value = await getActiveBoard()
      if (activeBoard.value.id) {
        bugForCurrentBoard.value = await loadBugReportsForActiveBoard(activeBoard.value.id)
      }
      isLoading.value = false
    })

    watch(() => activeBoard.value, async (newValue) => {
      if (newValue && newValue.id) {
        bugForCurrentBoard.value = await loadBugReportsForActiveBoard(newValue.id)
      }
    }, { immediate: true })

    const getInitials = (name) => {
      if (!name) return ''
      return name.split(' ').map(word => word[0]).join('').toUpperCase()
    }

    const createNewBoard = async () => {
      newBoardDialogVisible.value = false
      const { id } = await addDocToDb(newBoardForm.value)
      activeBoard.value = {
        id,
        ...newBoardForm.value
      }
      newBoardForm.value = {
        name: '',
        description: '',
        isActive: true
      }
    }

    const updateAssignment = (name, bug) => {
      bug.assignedTo = name
      const { handlelUpdate } = updateDocument('bugReports', bug.id)
      handlelUpdate({ assignedTo: name })
    }

    const moveToCurrentBoard = async (bug) => {
      if (Object.keys(selectedBugsInBacklog.value).length) {
        const selectedBugs = Object.keys(selectedBugsInBacklog.value)
        selectedBugs.forEach(async (id) => {
          const { handlelUpdate } = updateDocument('bugReports', id)
          await handlelUpdate({ boardId: activeBoard.value.id })
        })
        const bugs = backlogReports.value.filter(b => selectedBugs.includes(b.id))
        backlogReports.value = backlogReports.value.filter(b => !selectedBugs.includes(b.id))
        bugForCurrentBoard.value.push(...bugs)
        selectedBugsInBacklog.value = {}
        selectedBugsInBoard.value = {}
      } else {
        const { handlelUpdate } = updateDocument('bugReports', bug.id)
        await handlelUpdate({ boardId: activeBoard.value.id })
        backlogReports.value = backlogReports.value.filter(b => b.id !== bug.id)
        bugForCurrentBoard.value = await loadBugReportsForActiveBoard(activeBoard.value.id)
      }
    }

    const moveToBacklog = (bug) => {
      if (Object.keys(selectedBugsInBoard.value).length) {
        const selectedBugs = Object.keys(selectedBugsInBoard.value)
        selectedBugs.forEach(async (id) => {
          const { handlelUpdate } = updateDocument('bugReports', id)
          await handlelUpdate({ boardId: null })
        })
        const bugs = bugForCurrentBoard.value.filter(b => selectedBugs.includes(b.id))
        bugForCurrentBoard.value = bugForCurrentBoard.value.filter(b => !selectedBugs.includes(b.id))
        backlogReports.value.push(...bugs)
        selectedBugsInBacklog.value = {}
        selectedBugsInBoard.value = {}
      } else {
        const { handlelUpdate } = updateDocument('bugReports', bug.id)
        handlelUpdate({ boardId: null })
        bugForCurrentBoard.value = bugForCurrentBoard.value.filter(b => b.id !== bug.id)
        backlogReports.value.push(bug)
      }
    }

    const completeSprint = () => {
      const { handlelUpdate } = updateDocument('bugBoards', activeBoard.value.id)
      handlelUpdate({ isActive: false })
      activeBoard.value = null
    }

    // Toggle selection for bugs in the current board
    const toggleSelectionInBoard = (id) => {
      if (selectedBugsInBoard.value[id]) {
        delete selectedBugsInBoard.value[id]
      } else {
        selectedBugsInBoard.value[id] = true
      }
    }

    // Toggle selection for bugs in the backlog
    const toggleSelectionInBacklog = (id) => {
      if (selectedBugsInBacklog.value[id]) {
        delete selectedBugsInBacklog.value[id]
      } else {
        selectedBugsInBacklog.value[id] = true
      }
    }
    return {
      bugForCurrentBoard,
      isLoading,
      getInitials,
      backlogReports,
      newBoardDialogVisible,
      newBoardForm,
      boardFormRules,
      createNewBoard,
      activeBoard,
      updateAssignment,
      moveToCurrentBoard,
      moveToBacklog,
      completeSprint,
      toggleSelectionInBoard,
      toggleSelectionInBacklog,
      selectedBugsInBoard,
      selectedBugsInBacklog
    }
  }
}
</script>

<style scoped>
.bug-row {
  border-bottom: 1px solid #dfe1e6;
  padding: 10px 10px;
  transition: background-color 0.3s;
}

.bug-row:hover {
  background-color: #ebecf0;
}

.avatar {
    display: inline-block;
    background-color: var(--accent-color);
    color: white;
    font-weight: bold;
    font-size: 12px;
    width: 28px;
    height: 28px;
    line-height: 28px;
    border-radius: 50%;
    text-align: center;
    margin-right: 8px;
  }

  .sprint-header {
  display: flex; /* Establishes a flex container */
  justify-content: space-between; /* Places content at the start and end of the container */
  align-items: center; /* Centers items vertically */
}

.complete-sprint-btn {
  margin-left: auto; /* Pushes the button to the right */
}

.note-user, .operations-btn {
  margin-right: 5px;
}

.operations-btn {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.operations-btn i {
  font-size: 20px;
  color: #5e6c84;
}

.assign-to-select .avatar {
  margin-right: 5px; /* Spacing within select options */
}

.assign-to-select span {
  vertical-align: middle; /* Align the text and avatar vertically */
}

.backlog-container {
    background-color: #F4F5F7;
    padding: 10px;
    margin-top: 20px;
}

ul {
   background-color: white;
}

.summary {
    color: #172b4d;
}

.small-select {
    width: 120px !important;
}

.el-dropdown {
    vertical-align: sub !important;
}

.el-dropdown:hover {
    border: none !important;
}

</style>
